var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "boxRef", staticClass: "Box" }, [
    _c(
      "div",
      {
        ref: "selectClassRef",
        staticClass: "selectClass",
        staticStyle: { width: "100%" },
      },
      [
        _c(
          "el-form",
          { attrs: { model: _vm.queryForm } },
          [
            _c(
              "el-row",
              {
                staticStyle: { "flex-wrap": "wrap", "align-items": "center" },
                attrs: { type: "flex", justify: "start" },
              },
              [
                _c(
                  "el-col",
                  { attrs: { span: 10 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("collectionCenter.CreationTime"),
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: false,
                            "default-time": ["00:00:00", "23:59:59"],
                            "end-placeholder": _vm.$t(
                              "collectionCenter.EndTime"
                            ),
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "collectionCenter.StartTime"
                            ),
                            type: "datetimerange",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            size: "small",
                          },
                          on: { change: _vm.dateChange },
                          model: {
                            value: _vm.timeValue,
                            callback: function ($$v) {
                              _vm.timeValue = $$v
                            },
                            expression: "timeValue",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("collectionCenter.CustomerName"),
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "GlobalSetObj.Only10AreDisplayed"
                              ),
                              size: "small",
                              filterable: "",
                              multiple: "",
                              clearable: "",
                              remote: "",
                              "reserve-keyword": "",
                              "remote-method": _vm.getCustomerOption,
                            },
                            on: {
                              clear: function ($event) {
                                return _vm.getCustomerOption("")
                              },
                            },
                            model: {
                              value: _vm.queryForm.customerIdList,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "customerIdList", $$v)
                              },
                              expression: "queryForm.customerIdList",
                            },
                          },
                          _vm._l(_vm.customerOption, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label:
                                  item.customerAlias +
                                  "（" +
                                  item.username +
                                  "）",
                                value: item.id,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticStyle: { "text-align": "center" },
                    attrs: { span: 8 },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.search },
                      },
                      [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: { size: "mini", type: "info" },
                        on: { click: _vm.resetData },
                      },
                      [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                    ),
                    _c(
                      "el-radio-group",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: { size: "mini" },
                        on: { change: _vm.search },
                        model: {
                          value: _vm.queryForm.isTest,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "isTest", $$v)
                          },
                          expression: "queryForm.isTest",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: 1 } }, [
                          _vm._v(_vm._s(_vm.$t("newOrder.Formal"))),
                        ]),
                        _c("el-radio-button", { attrs: { label: 2 } }, [
                          _vm._v(_vm._s(_vm.$t("newOrder.test1"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "left-section" }, [
        _c(
          "div",
          { staticClass: "top-left" },
          [
            _c("div", { staticClass: "titleClass" }, [
              _vm._v(_vm._s(_vm.$t("collectionCenter.orderOverview"))),
            ]),
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "tl" }, [
                    _c("span", { staticClass: "tl-title" }, [
                      _vm._v(_vm._s(_vm.$t("collectionCenter.totalOrders"))),
                    ]),
                    _c("span", { staticClass: "tl-sum" }, [
                      _vm._v(_vm._s(_vm.orderTotal.totalOrders)),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "tl" }, [
                    _c("span", { staticClass: "tl-title" }, [
                      _vm._v(_vm._s(_vm.$t("navbar.totalNumber"))),
                    ]),
                    _c("span", { staticClass: "tl-sum" }, [
                      _vm._v(_vm._s(_vm.orderTotal.totalPieces)),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "tl" }, [
                    _c("span", { staticClass: "tl-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("collectionCenter.customerOrderCount"))
                      ),
                    ]),
                    _c("span", { staticClass: "tl-sum" }, [
                      _vm._v(_vm._s(_vm.orderTotal.customerCount)),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "bottom-left" }, [
          _c("div", { staticClass: "titleClass" }, [
            _vm._v(
              _vm._s(_vm.$t("collectionCenter.positiveWaybillMonitoring"))
            ),
          ]),
          _vm.optionsIsShow
            ? _c(
                "div",
                { staticStyle: { width: "100%" } },
                [_c("echarsBox", { attrs: { options: _vm.options } })],
                1
              )
            : _c("div", [_c("el-empty", { attrs: { "image-size": 200 } })], 1),
        ]),
      ]),
      _c("div", { staticClass: "right-section" }, [
        _c("div", { staticClass: "titleClass" }, [
          _vm._v(_vm._s(_vm.$t("collectionCenter.waybillMonitoring"))),
        ]),
        _vm.progressList.length > 0
          ? _c(
              "div",
              { staticClass: "right-box-class" },
              _vm._l(_vm.progressList, function (item, ind) {
                return _c(
                  "el-row",
                  {
                    key: ind,
                    staticStyle: {
                      "flex-wrap": "wrap",
                      "align-items": "center",
                    },
                    attrs: { type: "flex", justify: "flex-start" },
                  },
                  [
                    _c(
                      "el-col",
                      { staticClass: "status-name", attrs: { span: 5 } },
                      [_vm._v(_vm._s(item.waybillStatusName))]
                    ),
                    _c(
                      "el-col",
                      { staticClass: "progress-bar", attrs: { span: 16 } },
                      [
                        _c("el-progress", {
                          staticClass: "custom-progress",
                          attrs: {
                            percentage: item.countBar,
                            color:
                              item.waybillStatus === 2 ||
                              item.waybillStatus === 11 ||
                              item.waybillStatus === 17 ||
                              item.waybillStatus === 18 ||
                              item.waybillStatus === 15
                                ? "#cc0000"
                                : "#00a121",
                            "show-text": false,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { staticClass: "bar-num", attrs: { span: 3 } },
                      [_vm._v(_vm._s(item.count))]
                    ),
                  ],
                  1
                )
              }),
              1
            )
          : _c("div", [_c("el-empty", { attrs: { "image-size": 200 } })], 1),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }